import { ClientPostTypeEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

import {
  CalendarIcon,
  ForumIcon,
  GossipIcon,
  MarketIcon,
  NewsItemIcon,
  SuggestionIcon
} from '@/assets';
import {
  MeinOrtChannel,
  MeinOrtTab
} from '@/features/mein-ort/components/meinOrtTypes';
import { PostFeedType } from '@/features/posts/types/postFeed';
import type { SVGComponent } from '@/types';

export const POST_FEED_TYPE_ICONS: Record<PostFeedType, SVGComponent> = {
  [PostFeedType.GOSSIP]: ForumIcon,
  [PostFeedType.HAPPENING]: CalendarIcon,
  [PostFeedType.NEWS_ITEM]: NewsItemIcon,
  [PostFeedType.MARKET]: MarketIcon,
  [PostFeedType.SUGGESTION]: SuggestionIcon,
  [PostFeedType.SPECIAL_POST]: GossipIcon,
  [PostFeedType.CIVIL_PROTECTION]: NewsItemIcon,
  [PostFeedType.EMERGENCY]: NewsItemIcon,
  [PostFeedType.ALL]: () => <></>
};

export const POST_FEED_TYPE_POST_TYPE: Record<
  PostFeedType,
  ClientPostTypeEnum
> = {
  [PostFeedType.CIVIL_PROTECTION]: ClientPostTypeEnum.NewsItem,
  [PostFeedType.EMERGENCY]: ClientPostTypeEnum.NewsItem,
  [PostFeedType.GOSSIP]: ClientPostTypeEnum.Gossip,
  [PostFeedType.HAPPENING]: ClientPostTypeEnum.Happening,
  [PostFeedType.MARKET]: ClientPostTypeEnum.Offer,
  [PostFeedType.NEWS_ITEM]: ClientPostTypeEnum.NewsItem,
  [PostFeedType.SPECIAL_POST]: ClientPostTypeEnum.SpecialPost,
  [PostFeedType.SUGGESTION]: ClientPostTypeEnum.Suggestion,
  [PostFeedType.ALL]: ClientPostTypeEnum.Gossip
};

export const POST_TYPE_POST_FEED_TYPE: Record<
  ClientPostTypeEnum | PostFeedType,
  PostFeedType
> = {
  [ClientPostTypeEnum.Gossip]: PostFeedType.GOSSIP,
  [ClientPostTypeEnum.Happening]: PostFeedType.HAPPENING,
  [ClientPostTypeEnum.NewsItem]: PostFeedType.NEWS_ITEM,
  [ClientPostTypeEnum.Offer]: PostFeedType.MARKET,
  [ClientPostTypeEnum.Seeking]: PostFeedType.MARKET,
  [ClientPostTypeEnum.SpecialPost]: PostFeedType.SPECIAL_POST,
  [ClientPostTypeEnum.Suggestion]: PostFeedType.SUGGESTION,
  [PostFeedType.ALL]: PostFeedType.ALL,
  [PostFeedType.MARKET]: PostFeedType.MARKET,
  [PostFeedType.EMERGENCY]: PostFeedType.EMERGENCY,
  [PostFeedType.CIVIL_PROTECTION]: PostFeedType.CIVIL_PROTECTION
};

export const POST_FEED_TYPE_MEIN_ORT_TAB: Record<PostFeedType, MeinOrtTab> = {
  [PostFeedType.NEWS_ITEM]: MeinOrtTab.NEWS,
  [PostFeedType.GOSSIP]: MeinOrtTab.PLAUSCH,
  [PostFeedType.MARKET]: MeinOrtTab.MARKT,
  [PostFeedType.HAPPENING]: MeinOrtTab.EVENTS,
  [PostFeedType.CIVIL_PROTECTION]: MeinOrtTab.NEWS,
  [PostFeedType.EMERGENCY]: MeinOrtTab.NEWS,
  [PostFeedType.SUGGESTION]: MeinOrtTab.SAGSUNS,
  [PostFeedType.SPECIAL_POST]: MeinOrtTab.ALLE,
  [PostFeedType.ALL]: MeinOrtTab.ALLE
};

export const POST_FEED_TYPE_MEIN_ORT_CHANNEL: Record<
  PostFeedType,
  MeinOrtChannel
> = {
  [PostFeedType.NEWS_ITEM]: MeinOrtChannel.FUNKZENTRALE,
  [PostFeedType.GOSSIP]: MeinOrtChannel.FUNKZENTRALE,
  [PostFeedType.MARKET]: MeinOrtChannel.FUNKZENTRALE,
  [PostFeedType.HAPPENING]: MeinOrtChannel.FUNKZENTRALE,
  [PostFeedType.CIVIL_PROTECTION]: MeinOrtChannel.FUNKZENTRALE,
  [PostFeedType.EMERGENCY]: MeinOrtChannel.FUNKZENTRALE,
  [PostFeedType.SUGGESTION]: MeinOrtChannel.GRUPPEN,
  [PostFeedType.SPECIAL_POST]: MeinOrtChannel.FUNKZENTRALE,
  [PostFeedType.ALL]: MeinOrtChannel.FUNKZENTRALE
};

export const POST_TYPE_ICONS: Record<
  ClientPostTypeEnum | PostFeedType,
  SVGComponent
> = {
  [ClientPostTypeEnum.Gossip]: ForumIcon,
  [ClientPostTypeEnum.Happening]: CalendarIcon,
  [ClientPostTypeEnum.NewsItem]: NewsItemIcon,
  [ClientPostTypeEnum.Offer]: MarketIcon,
  [ClientPostTypeEnum.Seeking]: MarketIcon,
  [ClientPostTypeEnum.Suggestion]: SuggestionIcon,
  [ClientPostTypeEnum.SpecialPost]: GossipIcon,
  [PostFeedType.ALL]: GossipIcon,
  [PostFeedType.MARKET]: MarketIcon,
  [PostFeedType.EMERGENCY]: NewsItemIcon,
  [PostFeedType.CIVIL_PROTECTION]: GossipIcon
};
